import { cn } from '@lombok/ui';

/**
 * PLACEHOLDER brand lockup. The final Lombok logo and wordmark are PENDING —
 * this is an abstract mark + wordmark built from tokens so swapping the real
 * asset later is a single-component change. `variant="light"` is for dark
 * surfaces (e.g. the public landing / footer).
 */
export function Logo({
  className,
  variant = 'dark',
  showWordmark = true,
}: {
  className?: string;
  variant?: 'dark' | 'light';
  showWordmark?: boolean;
}) {
  const wordColor = variant === 'light' ? 'text-brand-white' : 'text-brand-primary';
  return (
    <span className={cn('inline-flex items-center gap-2', className)} aria-label="Lombok">
      <svg viewBox="0 0 32 32" className="h-full w-auto" role="img" aria-hidden="true">
        <rect width="32" height="32" rx="8" fill="var(--brand-mark)" />
        <g fill="none" stroke="var(--brand-accent)" strokeWidth="1.6" strokeLinecap="round">
          <path d="M8 22 16 10 24 22" />
          <path d="M11 22 16 15 21 22" opacity="0.6" />
        </g>
        <circle cx="16" cy="10" r="1.8" fill="var(--brand-accent)" />
      </svg>
      {showWordmark ? (
        <span className={cn('text-base font-semibold tracking-tight', wordColor)}>
          Lombok
        </span>
      ) : null}
    </span>
  );
}
